export const styles = {
  closeButton: (theme) => ({
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.danger.main,
    border: `3px solid ${theme.palette.danger.main}`,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.background.default,
      transform: "scale(1.2)",
    },
    alignSelf: "flex-end",
    top: 10,
    right: 10,
  }),
  divider: (theme) => ({
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    marginBottom: "15px",
    paddingBottom: "15px",
    color: theme.palette.common.black,
    mx: 2,
  }),
  input: {
    border: `1px solid gray`,
    borderRadius: "20px",
    padding: "0px 10px",
    textAlign: "center",
    marginLeft: "15px",
  },
  button: {
    textTransform: "none",
  },
  yesNoButton: (theme) => ({
    textTransform: "none",
    fontSize: 16,
    borderRadius: "30px",
    padding: "0px 15px",
    border: "none",
    color: theme.palette.common.black,
    backgroundColor: theme.palette.grey.lighter1,
    mx: "2px!important",
    "&:hover": {
      backgroundColor: theme.palette.grey.lighter1,
    },
  }),
  yesButton: (theme) => ({
    color: theme.palette.background.default,
    backgroundColor: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.main,
    },
  }),
  noButton: (theme) => ({
    color: theme.palette.common.default,
    backgroundColor: theme.palette.danger.main,
    "&:hover": {
      backgroundColor: theme.palette.danger.main,
    },
  }),
  shareWith: (theme) => ({
    width: "100%",
    padding: "5px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.default,
    textAlign: "center",
    mt: 1,
  }),
}
